export enum VehicleTypeEnum {
  TRAILER = 'TRAILER',
  TRUCK = 'TRUCK',
}
